/**
 * Vimeo video grid (rotating autoplay across .video-item iframes).
 *
 * Load-order safe: this file and the Vimeo player API are both deferred,
 * and this one appears earlier in the document (content-assets section),
 * so Vimeo may not exist yet when it executes — wait for player.js then.
 */
function initContentVideoGrid() {
  const videoIframes = document.querySelectorAll(".video-item iframe");
  const players = [];
  let currentIndex = 0;
  let rotationInterval;
  let isHovered = false;

  videoIframes.forEach((iframe, i) => {
    const player = new Vimeo.Player(iframe);
    players.push(player);

    player.setLoop(true);
    player.pause();
    player.loadVideo().catch(() => {});

    // Hover behavior
    const container = iframe.closest(".video-item");

    container.addEventListener("mouseenter", () => {
      isHovered = true;
      stopRotation();
      players.forEach((p, index) => {
        if (index === i) {
          p.play();
        } else {
          p.pause();
        }
      });
    });

    container.addEventListener("mouseleave", () => {
      isHovered = false;
      players[i].pause();
      startRotation(); // resume loop
    });
  });

  function playCurrentVideo() {
    players.forEach((p, i) => {
      const container = videoIframes[i].closest(".video-item");
      if (i === currentIndex) {
        p.play();
        container.classList.add("active");
      } else {
        p.pause();
        container.classList.remove("active");
      }
    });
  }

  function nextVideo() {
    if (isHovered) return; // don't change if hovered
    currentIndex = (currentIndex + 1) % players.length;
    playCurrentVideo();
  }

  function startRotation() {
    playCurrentVideo();
    rotationInterval = setInterval(nextVideo, 7000); // 7 seconds
  }

  function stopRotation() {
    clearInterval(rotationInterval);
  }

  // Start rotating on load
  startRotation();
}

if (typeof Vimeo !== "undefined") {
  initContentVideoGrid();
} else {
  var vimeoApiScript = document.querySelector('script[src*="player.vimeo.com/api/player.js"]');
  if (vimeoApiScript) {
    vimeoApiScript.addEventListener("load", initContentVideoGrid);
  }
}
